const ROOT_API = process.env.VUE_APP_ROOT_API;

const GET_TAX = ROOT_API + 'get_site_data/get_tax.php';
const GET_JOURNAL_LPO = ROOT_API + 'get_journal_lpo.php';
const GET_LPO_POINTS = ROOT_API + 'get_site_data/get_site_points.php';
const GET_INSPECTION_TYPES = ROOT_API + 'get_site_data/get_inspection_types.php';
const GET_MAIN_DAMAGE_REASONS = ROOT_API + 'get_site_data/get_main_damage_reasons.php';
const GET_RIGHT_MZL = ROOT_API + 'get_site_data/get_right_mzl.php';
const GET_AGIT_MZL_LIST = ROOT_API + 'get_site_data/get_agit_mzl_list.php';
const GET_PROF_MZL_LIST = ROOT_API + 'get_site_data/get_prof_mzl_list.php';
const GET_NEIGHBOR_MZL = ROOT_API + 'get_site_data/get_neighbor_mzl.php';
const GET_POLLUTIONS = ROOT_API + 'get_site_data/get_pollutions.php';
const GET_PERFORMERS = ROOT_API + 'get_site_data/get_performers.php';
const GET_PERFORMER = ROOT_API + 'get_site_data/get_performer.php';
const GET_TAX_COMPARISON = ROOT_API + 'get_site_data/get_tax_comparison.php';

const GET_FREQ_PEST = ROOT_API + 'get_site_data/get_freq_pest.php';
const GET_FREQ_DISEASE = ROOT_API + 'get_site_data/get_freq_disease.php';

const GET_LEASE = ROOT_API + 'get_lease.php';

const GET_VISUAL_SPECIES = ROOT_API + 'get_site_data/get_visual_species.php';
const GET_SPECIES_NAME_SHORT = ROOT_API + 'get_species_name_short.php';

import recount from './recount';
import mzl from './mzl';

import processJSON from '@/lib/processJSON';

export default {
	namespaced: true,

	modules: {
		recount,
		mzl
	},

	state: {
		lpo: null,
		savedPerformer: null,
		performers: [],
		pointList: [],
		mainDamageList: [],

		taxData: [],

		rightMzl: null,
		neighborMzl: null,
		agitMzlList: [],
		profMzlList: [],

		mzlNoNeedLoading: false,

		pollutionList: [],

		rightMzlIsLoading: false,

		leaseData: null,

		inspectionTypeList: [],

		taxComparison: [],

		freqDiseaseList: [],
		freqPestList: [],

		speciesTaxNotAccordIsLoading: false,
		visualSpeciesList: [],

		info_species_name_short: []
	},
	getters: {
		taxData(state) {
			return state.taxData[0]
		},
		lpoAddress(state) {
			if (state.lpo) {
				return state.lpo.forestry + ' / ' +
							 state.lpo.localforestry + ' / ' +
							 // state.lpo.subforestry + ' / ' +
							 (state.lpo.subforestry ? 
							 	(state.lpo.subforestry + ' / ') : '') +
							 state.lpo.area + ' / ' +
							 state.lpo.section +
							 (state.lpo.section_lp ? 
							 	(' / ' + state.lpo.section_lp) : '');
			}
			else {
				return '';
			}	
		},

		speciesTaxNotAccord(state) {
			return state.lpo.species_tax_accordance === 't' ? false : true;
		},
		visualTaxNotAccord(state) {
			return state.lpo.visual_tax_accordance === 't' ? false : true;
		},

		taxLayerList(state, getters) {
      if (state.taxData.length === 1 && !state.taxData[0].layer_id) {
        return [];
      }

      const result = [];
      for (const item of state.taxData) {
        if (!result.find(row => row.layer === item.layer)) {
          result.push(item);
        }
      }
      return result;
    },
    taxLayerSpeciesList: state => layer => {
      return state.taxData.filter(item => {
        return item.layer === layer.layer && item.tax_species_id;
      });
    },

    lpoVisualLayerList(state, getters) {
      if (state.visualSpeciesList.length === 1 && !state.visualSpeciesList[0].layer_id) {
        return [];
      }

      const result = [];
      for (const item of state.visualSpeciesList) {
        if (!result.find(row => row.layer === item.layer)) {
          result.push(item);
        }
      }
      return result;
    },
    lpoVisualLayerSpeciesList: state => layer => {
      return state.visualSpeciesList.filter(item => {
        return item.layer === layer.layer && item.tax_species_id;
      });
    },
	/*getSelectedLayers(state) {
		const layers = state.visualSpeciesList.filter((element) => {return element.tax_species_id }).map(item => { return item.layer});
		return layers.filter((el, ind) => ind === layers.indexOf(el))
	},
    */
	},
	mutations: {
		setPerformers(state, payload) {
			state.performers = payload
		},
		setPerformer(state, payload) {
			state.savedPerformer = payload
		},
		setVisualSpeciesList(state, payload) {
			state.visualSpeciesList = payload;
		},

		setSpeciesTaxNotAccordIsLoading(state, payload) {
			state.speciesTaxNotAccordIsLoading = payload;
		},

		setFreqPest(state, payload) {
			state['freqPestList'] = payload;
		},
		setFreqDisease(state, payload) {
			state['freqDiseaseList'] = payload;
		},

		setTax(state, payload) {
			state['taxData'] = payload;
		},

		setLpo(state, payload) {
			state['lpo'] = payload;
		},

		setPointList(state, payload) {
			state['pointList'] = payload;
		},

		setMainDamageList(state, payload) {
			state['mainDamageList'] = payload;
		},

		setAgitMzlList(state, payload) {
			state['agitMzlList'] = payload;
		},
		setProfMzlList(state, payload) {
			state['profMzlList'] = payload;
		},

		setMzlNoNeedLoading(state, payload) {
			state.mzlNoNeedLoading = payload;
		},

		setRightMzlIsLoading(state, payload) {
			state.rightMzlIsLoading = payload;
		},

		setRightMzl(state, payload) {
			state['rightMzl'] = payload;
		},

		setNeighborMzl(state, payload) {
			state['neighborMzl'] = payload;
		},

		setPollutionList(state, payload) {
			state['pollutionList'] = payload;
		},

		clearLpo(state, payload) {
			state['lpo'] = null;
			state['pointList'] = [];
			state['mainDamageList'] = [];
			state['taxData'] = [];
			state['rightMzl'] = null;
			state['agitMzlList'] = [];
			state['profMzlList'] = [];
			state['pollutionList'] = [];

			state['freqPestList'] = [];
			state['freqDiseaseList'] = [];

			state['taxComparison'] = [];
		},

		setInspectionTypeList(state, payload) {
			state['inspectionTypeList'] = payload;
		},
		setTaxComparison(state, payload) {
			state['taxComparison'] = payload;
		},

		setSpeciesNameShort(state, payload) {
      state['info_species_name_short'] = payload;
    },
	},
	actions: {
		getFreqPest(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo.lpo_id;

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetch(GET_FREQ_PEST, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				res = res.filter(item => { return item.z_degree != '-'; });
				commit('setFreqPest', res);

			})
			.catch(err => console.log(err));
		},
		getFreqDisease(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo.lpo_id;

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetch(GET_FREQ_DISEASE, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				res = res.filter(item => item.dmg_degree != '-');
				commit('setFreqDisease', res);
			})
			.catch(err => { throw err; });
		},


		getFreq(context, payload) {
			const { state, dispatch } = context;

			return Promise.all([
				dispatch('getFreqPest'),
				dispatch('getFreqDisease')
			]).then(res => {
				return dispatch('processFreq');
			})
		},

		processFreq(context, payload) {
			const { state, dispatch } = context;

			if (!state.lpo.pest_core_reason_id) {
				return;
			}

			let finded = null;
			if (state.freqPestList.length) {
				finded = state.freqPestList.find(pest => pest.pest_id == state.lpo.pest_core_reason_id);
			}

			if (!finded && state.freqDiseaseList.length) {
				finded = state.freqDiseaseList.find(pest => pest.disease_id == state.lpo.pest_core_reason_id);
			}

			if (!finded) {
				const values = [
					{
						field: 'pest_core_reason_id',
						value: null
					},
					{
						field: 'pest_id',
						value: null
					}
				];

				return dispatch('saveLpoValue', values).then(res => {
					return dispatch('updateLpo');
				});
			}
		},

		getTaxComparison(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo.lpo_id;

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetch(GET_TAX_COMPARISON, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setTaxComparison', res);
			})
			.catch(err => console.log(err));
		},

		updateTaxComparison(context, payload) {
			const { dispatch } = context;
			dispatch('getTaxComparison');
		},

		getInspectionTypeList(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo ? state.lpo.lpo_id: null;

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetch(GET_INSPECTION_TYPES, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setInspectionTypeList', res);
			})
			.catch(err => console.log(err));
		},
		getPerformers(context, payload) {
			const { state, commit } = context;

			const filial_id = payload;
			const lpo_id = state.lpo.lpo_id;
			const form = new FormData();
			form.append('filial_id', filial_id);
			form.append('lpo_id', lpo_id);

			return fetch(GET_PERFORMERS, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setPerformers', res);
			})
			.catch(err => console.log(err));
		},
		getPerformer(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo.lpo_id;

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetch(GET_PERFORMER, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setPerformer', res);
			})
			.catch(err => console.log(err));
		},

		removeLpo(context, payload) {
			const { state } = context;

			const lpo = state.lpo;

			const json_obj = [
				{
					'd': [
						{
							'tab_name': 'data_lpo',
							'id': lpo.lpo_id
						}
					]
				}
			];

			if (lpo.lease_id) {
				const tempLease = {
					'tab_name': 'data_lpo_lease',
					'id': lpo.lease_id
				};
				json_obj[0].d.push(tempLease);
			}

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);

		},
		updatePerformer(context, payload) {
			const { state } = context;

			const saved = state.savedPerformer;
			const savedIds = saved.map(item => item.id)
			const selected = payload;
			const toInsert = selected.filter(item => !savedIds.includes(item.id))
			const toDel = saved.filter(item => !selected.map(elem => elem.id).includes(item.id))
			let d = []
			let i = []
			toDel.forEach((element) => {
				d.push({
					'tab_name': 'data_lpo_performers',
					'id': element.uid
				})
			})
			toInsert.forEach((element) => {
				i.push({
					'tab_name': 'data_lpo_performers',
					'f_v': {
						'parent_id': state.lpo.lpo_id,
						'user_id': element.id
					}
				})
			})
			/*const json_obj = [
				{
					'd': [
						{
							'tab_name': 'data_lpo',
							'id': lpo.lpo_id
						}
					]
				}
			];
			*/
			const json_obj = [
				{
					'i': {tab: i},
				},
				{
					'd': d
				}
			];
			const json_str = JSON.stringify(json_obj);
			return processJSON(json_str);
		},
		saveS(context, payload) {
			const { state } = context;

			const lpo = state.lpo;
			const s = payload;

			// const f_v = {
			// 	'id': lpo.lpo_id,
			// 	's_lp_manual': s
			// };

			// if (!lpo.s_lp_calc) {
			// 	f_v.s_lp_calc = lpo.s_lp;
			// }

			const json_obj = [
				{
					'u': [
						{
							'tab_name': 'data_lpo',
							'f_v': {
								'id': lpo.lpo_id,
								's_lp_manual': s
							}
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},

		clearS(context, payload) {
			const { state } = context;

			const lpo = state.lpo;
			const s = payload;

			const json_obj = [
				{
					'u': [
						{
							'tab_name': 'data_lpo',
							'f_v': {
								'id': lpo.lpo_id,
								's_lp_manual': null,
							}
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},

		getTax(context, payload) {
			const { state, commit } = context;

			// const tax_id = payload;

			const tax_id = state.lpo['tax_id'];

			const form = new FormData();
			form.append('tax_id', tax_id);

			return fetch(GET_TAX, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setTax', res);
			})
			.catch(err => console.log(err));
		},

		/* VISUAL SPECIES */
		getVisualSpecies(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo['lpo_id'];

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetch(GET_VISUAL_SPECIES, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setVisualSpeciesList', res);
			})
			.catch(err => { throw err; });
		},
		clearVisualSpecies(context, payload) {
			const { commit } = context;
			commit('setVisualSpeciesList', []);
		},
		updateVisualSpecies(context, payload) {
			const { dispatch } = context;
			return dispatch('getVisualSpecies');
		},

		addLpoVisualLayer(context, payload) {
			const { state, getters } = context;
			const { composition, fullness, stock, layer } = payload;

			const lpo_id = state.lpo.lpo_id;
			//console.log(getters.lpoVisualLayerList.filter((item) => {return item.layer !== "11"}).length)
			const json_obj = [
				{
					'i': {
						'tab': [
							{
								'tab_name': 'data_lpo_visual_layer',
								'f_v': {
									'parent_id': lpo_id,
									'layer': layer ? layer: getters.lpoVisualLayerList.filter((item) => {return item.layer !== "11"}).length + 1, //было: 'layer': layer ? layer: getters.lpoVisualLayerList.length + 1,
									'composition': composition,
									'fullness': fullness,
									'stock': stock
								}
							}
						]
					}
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},
		removeLpoVisualLayer(context, layer) {
			const { getters } = context;

			const updateSection = [];
			for (const itemLayer of getters.lpoVisualLayerList) {
				if (+itemLayer.layer > +layer.layer) {
					const temp = {
						'tab_name': 'data_lpo_visual_layer',
						'f_v': {
							'id': itemLayer.layer_id,
							'layer': +itemLayer.layer - 1
						}
					};
					updateSection.push(temp);
				}
			}

			const json_obj = [
				{
					'u': updateSection
				},
				{
					'd': [
						{
							'tab_name': 'data_lpo_visual_layer',
							'id': layer.layer_id
						}
					]
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},

		addLpoVisualSpecies(context, payload) {
			const { state, getters } = context;

			const layer = payload.layer;
			const species = payload.species;

			const json_obj = [
				{
					'i': {
						'tab': [
							{
								'tab_name': 'data_lpo_visual_layer_species',
								'f_v': {
									'parent_id': layer.layer_id,
									'species_num': getters.lpoVisualLayerSpeciesList(layer).length + 1,
									'species_id': species.species.id,
									'name': species.species.name,
									'name_short': species.name_short,
									'gen': species.gen,
									'coeff': species.coeff === '+' ? '0' : species.coeff,
									'age': species.age,
									'h': species.h,
									'd': species.d,
								}
							}
						]
					}
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},
		removeLpoVisualSpecies(context, payload) {
			
			const { state, getters } = context;
			const species = payload.species;
			const layer = payload.species.layer;
			//console.log(getters.lpoVisualLayerSpeciesList({layer: "1"}))
			//console.log(getters.getSelectedLayers)
			//console.log(species)
			const updateSection = [];
			for (const itemSpecies of getters.lpoVisualLayerSpeciesList({layer: layer})) {
				if (+itemSpecies.species_num > +species.species_num) {
					const temp = {
						'tab_name': 'data_lpo_visual_layer_species',
						'f_v': {
							'id': itemSpecies.tax_species_id,
							'species_num': +itemSpecies.species_num - 1
						}
					};
					updateSection.push(temp);
				}
			}

			const json_obj = [
				{
					'u': updateSection
				},
				{
					'd': [
						{
							'tab_name': 'data_lpo_visual_layer_species',
							'id': species.tax_species_id
						}
					]
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},

		getSpeciesNameShort(context, species) {
      const { commit } = context;

      // console.log('species', species);

      const form = new FormData();
      form.append('species_id', species.id);

      fetch(GET_SPECIES_NAME_SHORT, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        commit('setSpeciesNameShort', res);
      })
      .catch(err => console.log(err));
    },


		getLpo(context, payload) {
			const { state, rootState, commit } = context;

			const lpo_id = payload;

			const filter = `lpo_id=''${lpo_id}''`;

			const form = new FormData();
			form.append('current_page', 1);
			form.append('per_page', 1);
			form.append('filter', filter);
			form.append('user_id', rootState.auth.userId);

			return fetch(GET_JOURNAL_LPO, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setLpo', res[0]);
			})
			.catch(err => { throw err; });
		},

		updateLpo(context, payload) {
			const { state, dispatch } = context;

			return dispatch('getLpo', state.lpo.lpo_id);
		},

		getLpoAll(context, payload) {
			const { state, commit, dispatch } = context;

			const lpo_id = payload;

			commit('clearLpo');

			return dispatch('getLpo', lpo_id).then(res => {
				dispatch('getPointList');
				dispatch('getMainDamageList');
				dispatch('getTax');
				//dispatch('getRightMzl');
				dispatch('getNeighborMzl');
				dispatch('getAgitMzlList');
				dispatch('getProfMzlList');

				if (state.lpo.need_visual === 't') {
					dispatch('getPollutions');
				}

				if (state.lpo.species_tax_accordance !== 't') {
					dispatch('getVisualSpecies');
				}
			});
		},

		/* POINTS */
		getPointList(context, payload) {
			const { state, commit } = context;

			const form = new FormData();
			form.append('lpo_id', state.lpo.lpo_id);

			return fetch(GET_LPO_POINTS, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setPointList', res);
			})
			.catch(err => console.log(err));
		},

		updatePointList(context, payload) {
			const { dispatch } = context;
			dispatch('getPointList');
		},

		addPoint(context, payload) {
			const { state, dispatch } = context;

			const point = payload;

			const updateSection = [];
			for (let i = +point.after; i < state.pointList.length; ++i) {
				const updatedPoint = state.pointList[i];

				const temp = {
					'tab_name': 'data_lpo_points',
					'f_v': {
						'id': updatedPoint.id,
						'point_num': +updatedPoint.point_num + 1
					}
				};

				updateSection.push(temp);
			}

			const json_renum_obj = [
				{
					'u': updateSection
				}
			];

			const json_renum_str = JSON.stringify(json_renum_obj);
			// console.log(json_renum_str);
			// return;

			const json_obj = [
				{
					'i': {
						'tab': [
							{
								'tab_name': 'data_lpo_points',
								'f_v': {
									'parent_id': state.lpo.lpo_id,
									'point_num': Number(point.after) + 1,
									'lat': point.lat,
									'lon': point.lon
								}
							}
						]
					}
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_renum_str).then(res => {
				return processJSON(json_str);
			});
		},

		removePoint(context, payload) {
			const { state } = context;

			const point = payload;

			const updateSection = [];
			for (let i = +point.point_num; i < state.pointList.length; ++i) {
				const updatedPoint = state.pointList[i];

				const temp = {
					'tab_name': 'data_lpo_points',
					'f_v': {
						'id': updatedPoint.id,
						'point_num': i
					}
				};

				updateSection.push(temp);
			}

			const json_renum_obj = [
				{
					'u': updateSection
				}
			];

			const json_renum_str = JSON.stringify(json_renum_obj);
			// console.log(json_renum_str);
			// return;

			const json_obj = [
				{
					'd': [
						{
							'tab_name': 'data_lpo_points',
							'id': point.id
						}
					]
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str).then(res => {
				return processJSON(json_renum_str);
			});

		},

		addPointList(context, points) {
			const { state, dispatch } = context;

			// console.log(JSON.stringify(points, null, 2));
			const insertSection = [];
			for (let i = 0; i < points.length; ++i) {
				const point = points[i];

				const temp = {
					'tab_name': 'data_lpo_points',
					'f_v': {
						'parent_id': state.lpo.lpo_id,
						'point_num': i + 1,
						'lat': point.lat,
						'lon': point.lon,
					}
				};

				insertSection.push(temp);
			}

			const json_obj = [
				{
					'i': {
						'tab': insertSection
					}
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return dispatch('removeAllLpoPoints').then(res => {
				return processJSON(json_str);
			});
		},
		removeAllLpoPoints(context, points) {
			const { state } = context;

			const deleteSection = [];
			for (const point of state.pointList) {
				const temp = {
					'tab_name': 'data_lpo_points',
					'id': point.id
				};
				deleteSection.push(temp);
			}

			const json_obj = [
				{
					'd': deleteSection
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},

		/* OTHER */
		getMainDamageList(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo['lpo_id'];

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetch(GET_MAIN_DAMAGE_REASONS, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setMainDamageList', res);
			})
			.catch(err => { throw err; });
		},

		updateMainDamageList(context, payload) {
			const { dispatch } = context;
			return dispatch('getMainDamageList');
		},

		saveMainDamageList(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo['lpo_id'];

			const damageList = payload;

			// console.log('damages: ', damageList);

			const deleteSection = [];
			for (const damage of state.mainDamageList) {
				const temp = {
					'tab_name': 'data_lpo_main_damages',
					'id': damage.id
				};
				deleteSection.push(temp);
			};

			const json_delete_obj = [
				{
					'd': deleteSection
				}
			];
			const json_delete_str = JSON.stringify(json_delete_obj);
			// console.log(json_delete_str);
			// return;

			const insertSection = [];
			for (const damage of damageList) {
				const temp = {
					'tab_name': 'data_lpo_main_damages',
					'f_v': {
						'parent_id': lpo_id,
						'reason_id': damage.id
					}
				};
				insertSection.push(temp);
			}

			const json_obj = [
				{
					'i': {
						'tab': insertSection
					}
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str).then(res => {
				return processJSON(json_delete_str);
			});
		},

		/* SAVING */
		saveLpoValue(context, payload) {
			const { state } = context;

			const valueList = payload;

			const f_v_rest = {};
			for (const item of valueList) {
				f_v_rest[item.field] = item.value;
			}

			const json_obj = [
				{
					'u': [
						{
							'tab_name': 'data_lpo',
							'f_v': {
								'id': state.lpo.lpo_id,
								...f_v_rest
							}
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);
			// return;

			return processJSON(json_str);
		},
		toggleNeedVisual(context, payload) {
			const { state } = context;

			const value = payload;

			const json_obj = [
				{
					'u': [
						{
							'tab_name': 'data_lpo',
							'f_v': {
								'id': state.lpo.lpo_id,
								'need_visual': value,
								'forecast_s_pests': null,
								'forecast_s_shrinking': null,
								'forecast_s_weakening': null
							}
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;


			return processJSON(json_str);
		},
		toggleNeedAsteriskFact(context, payload) {
			const { state } = context;

			const value = payload;

			const json_obj = [
				{
					'u': [
						{
							'tab_name': 'data_lpo',
							'f_v': {
								'id': state.lpo.lpo_id,
								'need_asterisk_fact': value
							}
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);
			return processJSON(json_str);
		},
		toggleNeedAllSpAnnex1(context, payload) {
			const { state } = context;

			const value = payload;

			const json_obj = [
				{
					'u': [
						{
							'tab_name': 'data_lpo',
							'f_v': {
								'id': state.lpo.lpo_id,
								'need_all_sp_annex1': value
							}
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);
			return processJSON(json_str);
		},
		toggleSpeciesTaxAccordance(context, payload) {
			const { state, commit } = context;

			const value = payload;

			const json_obj = [
				{
					'u': [
						{
							'tab_name': 'data_lpo',
							'f_v': {
								'id': state.lpo.lpo_id,
								'species_tax_accordance': value,
							}
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			commit('setSpeciesTaxNotAccordIsLoading', true);

			return processJSON(json_str).then(res => {
				commit('setSpeciesTaxNotAccordIsLoading', false);
			});
		},

		/* MZL */
		mzlNoNeedChanged(context, payload) {
			const { state, commit } = context;

			const checked = payload;
			// console.log(checked);

			let json_obj = null;

			if (!checked && state.rightMzl.id) {

				json_obj = [
					{
						'd': [
							{
								'tab_name': 'data_lpo_mzl',
								'id': state.rightMzl.id,
							}
						]
					}
				];

			} else if (checked && !state.rightMzl.id) {

				json_obj = [
					{
						'i': {
							'tab': [
								{
									'tab_name': 'data_lpo_mzl',
									'f_v': {
										'parent_id': state.lpo.lpo_id,
										'mzl_id': '0',
										'is_neighbor': false
									}
								}
							]
						}
					}
				];

			}
			

			if (!json_obj) {
				return;
			}

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			commit('setMzlNoNeedLoading', true);

			return processJSON(json_str).finally(() => {
				commit('setMzlNoNeedLoading', false);
			});

		},

		getRightMzl(context, payload) {
			const { state, commit, dispatch } = context;

			const lpo = state.lpo;

			const form = new FormData();
			form.append('lpo_id', lpo.lpo_id);

			commit('setRightMzlIsLoading', true);

			return fetch(GET_RIGHT_MZL, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setRightMzl', res[0]);

				if (state.rightMzl.is_manual !== 't' && state.rightMzl.id && state.rightMzl.mzl_id !== '0') {
					dispatch('removeRightMzl');
				}
				
			})
			.catch(err => { console.log('!GET_RIGHT_MZL error'); })
			.finally(() => { commit('setRightMzlIsLoading', false); });
		},

		updateRightMzl(context, payload) {
			const { dispatch } = context;
			return dispatch('getRightMzl');
		},

		saveRightMzl(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo['lpo_id'];

			const right = payload;

			// return;

			// console.log('damages: ', damageList);

			const deleteSection = [];

			if (state.rightMzl && state.rightMzl.id) {
				const temp = {
					'tab_name': 'data_lpo_mzl',
					'id': state.rightMzl.id
				};
				deleteSection.push(temp);
			}

			const insertSection = [];

			if (right.id) {
				const temp = {
					'tab_name': 'data_lpo_mzl',
					'f_v': {
						'parent_id': lpo_id,
						'mzl_id': right.id,
						'is_neighbor': false
					}
				};
				insertSection.push(temp);
			}

			const json_obj = [
				{
					'i': {
						'tab': insertSection
					}
				},
				{
					'd': deleteSection
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},

		removeRightMzl(context, payload) {
			const { state, commit } = context;

			const json_obj = [
				{
					'd': [
						{
							'tab_name': 'data_lpo_mzl',
							'id': state.rightMzl.id
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},

		getNeighborMzl(context, payload) {
			const { state, commit } = context;

			const lpo = state.lpo;

			const form = new FormData();
			form.append('lpo_id', lpo.lpo_id);

			return fetch(GET_NEIGHBOR_MZL, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setNeighborMzl', res.length ? res[0] : null);
			})
			.catch(err => { throw err; });
		},

		updateNeighborMzl(context, payload) {
			const { dispatch } = context;
			return dispatch('getNeighborMzl');
		},

		saveNeighborMzl(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo['lpo_id'];

			const neighbor = payload;

			console.log(neighbor);
			// return;

			// console.log('damages: ', damageList);

			const deleteSection = [];

			if (state.neighborMzl) {
				const temp = {
					'tab_name': 'data_lpo_mzl',
					'id': state.neighborMzl.id
				};
				deleteSection.push(temp);
			}

			const json_delete_obj = [
				{
					'd': deleteSection
				}
			];
			const json_delete_str = JSON.stringify(json_delete_obj);
			console.log(json_delete_str);
			// return;

			const insertSection = [];

			if (neighbor.id) {
				const temp = {
					'tab_name': 'data_lpo_mzl',
					'f_v': {
						'parent_id': lpo_id,
						'mzl_id': neighbor.id,
						'is_neighbor': true
					}
				};
				insertSection.push(temp);
			}

			const json_obj = [
				{
					'i': {
						'tab': insertSection
					}
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str).then(res => {
				return processJSON(json_delete_str);
			});
		},

		getAgitMzlList(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo['lpo_id'];

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetch(GET_AGIT_MZL_LIST, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setAgitMzlList', res);
			})
			.catch(err => { throw err; });
		},

		updateAgitMzlList(context, payload) {
			const { dispatch } = context;
			return dispatch('getAgitMzlList');
		},

		saveAgitMzlList(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo['lpo_id'];

			const mzlList = payload;

			// console.log('damages: ', damageList);

			const deleteSection = [];
			for (const mzl of state.agitMzlList) {
				const temp = {
					'tab_name': 'data_lpo_mzl',
					'id': mzl.id
				};
				deleteSection.push(temp);
			};

			const json_delete_obj = [
				{
					'd': deleteSection
				}
			];
			const json_delete_str = JSON.stringify(json_delete_obj);
			// console.log(json_delete_str);
			// return;

			const insertSection = [];
			for (const mzl of mzlList) {
				const temp = {
					'tab_name': 'data_lpo_mzl',
					'f_v': {
						'parent_id': lpo_id,
						'mzl_id': mzl.id,
						'is_neighbor': false
					}
				};
				insertSection.push(temp);
			}

			const json_obj = [
				{
					'i': {
						'tab': insertSection
					}
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str).then(res => {
				return processJSON(json_delete_str);
			});
		},

		getProfMzlList(context, payload) {
			const { state, commit } = context;

			const lpo_id = state.lpo['lpo_id'];

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetch(GET_PROF_MZL_LIST, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setProfMzlList', res);
			})
			.catch(err => { throw err; });
		},

		updateProfMzlList(context, payload) {
			const { dispatch } = context;
			return dispatch('getProfMzlList');
		},

		saveProfMzlList(context, payload) {

			const { state, commit } = context;

			const lpo_id = state.lpo['lpo_id'];

			const mzlList = payload;

			// console.log('damages: ', damageList);

			const deleteSection = [];
			for (const mzl of state.profMzlList) {

				if (['7', '10'].includes(state.lpo.inspection_type_id) && mzl.mzl_id === '370') {
					continue;
				}

				const temp = {
					'tab_name': 'data_lpo_mzl',
					'id': mzl.id
				};
				deleteSection.push(temp);
			};

			const json_delete_obj = [
				{
					'd': deleteSection
				}
			];
			const json_delete_str = JSON.stringify(json_delete_obj);
			// console.log(json_delete_str);
			// return;

			const insertSection = [];
			for (const mzl of mzlList) {
				const temp = {
					'tab_name': 'data_lpo_mzl',
					'f_v': {
						'parent_id': lpo_id,
						'mzl_id': mzl.id,
						'is_neighbor': false
					}
				};
				insertSection.push(temp);
			}

			const json_obj = [
				{
					'i': {
						'tab': insertSection
					}
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_delete_str).then(res => {
				return processJSON(json_str);
			});

			// return processJSON(json_str).then(res => {
			// 	return processJSON(json_delete_str);
			// });
		},

		/* POLLUTIONS */
		getPollutions(context, payload) {
			const { state, commit } = context;

			const lpo = state.lpo;

			const form = new FormData();
			form.append('lpo_id', lpo.lpo_id);

			return fetch(GET_POLLUTIONS, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setPollutionList', res);
			})
			.catch(err => { throw err; });
		},

		updatePollutionList(context, payload) {
			const { dispatch } = context;

			return dispatch('getPollutions');
		},

		savePollutions(context, payload) {
			console.log(payload);
		},

		addPollution(context, payload) {
			const { state } = context;

			const pollution = payload;

			console.log('add', pollution);

			const pollutionSize = '{' +
				pollution.length + ',' +
				pollution.width + ',' +
				pollution.height + '}';

			const json_obj = [
				{
					'i': {
						'tab': [
							{
								'tab_name': 'data_lpo_pollution',
								'f_v': {
									'parent_id': state.lpo.lpo_id,
									'pollution_id': pollution.pollution.id,
									'pollution_size': pollutionSize
								}
							}
						]
					}
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},
		removePollution(context, payload) {
			console.log(payload);

			const pollution = payload;

			const json_obj = [
				{
					'd': [
						{
							'tab_name': 'data_lpo_pollution',
							'id': pollution.id
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		}
	}
};